import { useState } from "react";
import { collection, doc, addDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { 
    MdClose
} from 'react-icons/md';

const EditCategory = (props) => {

    const [name, setName] = useState(props.new ? '':props.menu.name);
    const [description, setDescription] = useState(props.new ? '':props.menu.description);
    
    const save = async () => {

        if(name.trim().length == 0){
            return window.alert('Ingresa un nombre valido.');
        }

        if(props.new){
            const newList = props.menuList.slice();
            const newCat = {name: name, description: description, dishes: []};
            newList.push(newCat);
            props.setMenuList(newList);
            setTimeout(() => props.setCurrent(newCat), 10);

            addDoc(collection(props.eDB, `Restaurants/${props.resID}/Menu`), newCat);
            props.close();
        }else if(props.delete){
            const newList = props.menuList.filter((cat) => {
                return cat != props.menu;
            });
            props.setMenuList(newList);

            const menuRef = doc(props.eDB, `Restaurants/${props.resID}/Menu/${props.menuID}`);
            console.log("Deleting: ", `Restaurants/${props.resID}/Menu/${props.menuID}`);
            deleteDoc(menuRef);

            props.close();
        }else{
            const newList = props.menuList.slice();
            newList[props.menuPos] = {...props.menu, name: name, description: description};
            setTimeout(() => props.setCurrent(newList[props.menuPos]), 10);
            props.setMenuList(newList);

            const menuRef = doc(props.eDB, `Restaurants/${props.resID}/Menu/${props.menuID}`);
            setDoc(menuRef, newList[props.menuPos], {merge: true})
            .then((result) => {
                console.log("Values applied to eDB");
            });

            props.close();
        }

        //props.export('Contacts', props.contactsPos, 'contacts', newContacts[props.contactsPos]);
    }

    return (
        <>
            <div>
                Nombre: <input type='text' value={name} onChange={(e) => setName(e.target.value)} disabled={props.delete} />
            </div>
            <div className='mt-1'>
                Description: <br/><textarea style={{width: '100%', minHeight: '120px'}} value={description} onChange={(e) => setDescription(e.target.value)} disabled={props.delete} />
            </div>
            <div className="mt-2">
                <button className={props.delete? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={save}>{props.delete?'Borrar':'Guardar'}</button>
            </div>
        </>
    );
}

export default EditCategory;